// extracted by mini-css-extract-plugin
export default {"backButton":"dialogHeader_backButton__pH9KA"};